import fetchBuilder from 'fetch-retry'

export const fetchApi = fetchBuilder(fetch)
